
import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTeacherSearch } from "@/hooks/useTeacherSearch";
import { Loader2 } from "lucide-react";

interface TeacherScheduleSearchProps {
  onSelectTeacher: (teacher: { code: string; name: string }) => void;
}

export function TeacherScheduleSearch({ onSelectTeacher }: TeacherScheduleSearchProps) {
  const { searchQuery, setSearchQuery, teachers, isLoading, search } = useTeacherSearch();

  useEffect(() => {
    if (searchQuery.length >= 2) {
      const searchTimer = setTimeout(() => {
        search(searchQuery);
      }, 500);

      return () => clearTimeout(searchTimer);
    }
  }, [searchQuery, search]);

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
      <h2 className="text-xl font-semibold mb-4">ค้นหาตารางสอนของครู</h2>
      
      <div className="flex gap-2 mb-4">
        <Input
          placeholder="ค้นหาครู (ชื่อ, รหัส)"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full"
        />
        <Button 
          onClick={() => search(searchQuery)}
          disabled={searchQuery.length < 2 || isLoading}
        >
          {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'ค้นหา'}
        </Button>
      </div>
      
      {isLoading ? (
        <div className="flex justify-center py-4">
          <Loader2 className="h-6 w-6 animate-spin text-blue-500" />
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
          {teachers.map((teacher) => (
            <Button
              key={teacher.code}
              variant="outline"
              className="text-left justify-start h-auto py-2"
              onClick={() => onSelectTeacher({ 
                code: teacher.code,
                name: teacher.name
              })}
            >
              <div>
                <div className="font-medium">{teacher.name}</div>
                <div className="text-xs text-gray-500">รหัส: {teacher.code}</div>
              </div>
            </Button>
          ))}

          {teachers.length === 0 && searchQuery.length >= 2 && (
            <div className="col-span-full text-center py-4 text-gray-500">
              ไม่พบข้อมูลครู กรุณาค้นหาใหม่อีกครั้ง
            </div>
          )}
        </div>
      )}
    </div>
  );
}
